<template>
    <!-- 问卷统计 -->
    <div class="stat-container">
        <div class="header">
            <Header/>
        </div>
        <div class="app-width">
            <go-back content="问卷分析"
                     title="回到问卷列表"
                     :before-back="onBeforeBack"
                     style="padding: 30px 0 30px 0"/>
            <question-stat :question="question"
                           :key="question.id"
                           :is-admin="false"
                           :number="index + 1"
                           v-for="(question, index) in questionList"/>
        </div>
    </div>
</template>

<script>
// 标题
// 问卷试题统计
import QuestionStat from "@/components/questionStat";
import { getStatData } from "@/api/new-question-iteration/question-library"
import { uuid, toFixed, numberToWord } from "@/utils";
import { QUESTION_NUM_VAL, isUrl, QUESTION_VAL } from "@/utils/question-config";
import NP from "number-precision" // 引入该库解决浮点数精度问题
import Header from "@/components/header";
export default {
    name: "QuestionnaireAnalyse",
    components: {
        QuestionStat,
        Header
    },
    data() {
        return {
            questionList: []
        }
    },
    created() {
        this.getStatData()
    },
    methods: {
        // 获取统计数据
        getStatData() {
            const Qid = this.$route.query.Qid
            if (!Qid) return
            getStatData(Qid).then(res => {
                const { AvgTime, numCount, stuCountDate, QuestionnaireDetailViewlist = [] } = res || {}
                const questionList = QuestionnaireDetailViewlist.map(item => {
                    const { Title, Options, Type, Remark, count, IsMustAnswer, ...otherProps } = item
                    let countMapObj = Object.create(null)
                    // 最后一个选择的项
                    let lastWord
                    if (Array.isArray(count)) {
                        // 将count转为对象
                        countMapObj = count.reduce((preVal, curVal) => {
                            const [key, value] = Object.entries(curVal)[0]
                            preVal[key] = parseInt(value)
                            return preVal
                        }, Object.create(null))
                        // 升序排列key
                        const ascSort = Object.keys(countMapObj).sort((a, b) => a.charCodeAt(0) - b.charCodeAt(0))
                        lastWord = ascSort[ascSort.length - 1]
                    }
                    const isHasOptionsQuestion = [QUESTION_VAL.single, QUESTION_VAL.multiple].includes(QUESTION_NUM_VAL[Type])
                    const optionsQuestionTotal = Object.values(countMapObj).reduce((preVal, curVal) => {
                        preVal = preVal + curVal
                        return preVal
                    }, 0)
                    let percentage = 0
                    const questionOptions = (isHasOptionsQuestion && typeof Options === "string" && Options.split("|"))
                    return {
                        stem: Title,
                        options: Array.isArray(questionOptions) ? questionOptions.map((item, index) => {
                            const word = numberToWord(index + 1)
                            const currentPercentage = parseFloat((toFixed((((countMapObj[word] || 0) / optionsQuestionTotal) * 100), 2))) || 0
                            // 解决浮点数精度问题
                            percentage = word === lastWord ? percentage : NP.plus(percentage, currentPercentage)
                            return {
                                type: isUrl(item) ? "image" : "text",
                                text: item,
                                count: countMapObj[word] || 0,
                                percentage: word === lastWord ? (optionsQuestionTotal === 0 ? 0 : NP.minus(100, percentage)) : currentPercentage
                            }
                        }) : Options,
                        type: QUESTION_NUM_VAL[Type],
                        remark: Remark,
                        participants: isHasOptionsQuestion ? optionsQuestionTotal : item.answer.length, // 参与人数
                        required: !!IsMustAnswer,
                        count,
                        no: uuid(5),
                        ...otherProps
                    }
                })
                console.log(questionList, "questionList");
                this.questionList = questionList
            })
        },
        onBeforeBack (fn) {
            if (this.$route.query.from) {
                this.$router.push(this.$route.query.from)
            } else {
                fn()
            }
        }
    }
}
</script>

<style scoped lang="less">
.header {
    height: 70px;
}
</style>
